import { timefitBackend } from '../../../Shared/Services/TimefitBackend';
import { keys } from '../../../Shared/Services/Query/Keys.ts';
import { useInfiniteList } from '../../../Shared/Hooks/useInfiniteList/useInfiniteList.ts';

export function usePostsInfiniteList() {
  const queryFn = ({ pageParam = undefined }) => {
    return timefitBackend.getPosts({ cursorKey: pageParam });
  };

  return useInfiniteList(keys.posts.list(), queryFn);
}
